// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

/* eslint-disable */

import 'babel-polyfill'  
import Vue from 'vue'
import App from './App'
import router from './router'


//VUEX 
import Vuex from 'vuex'
Vue.use(Vuex)
import { store } from '@/store/store.js';
//.VUEX 

//AXIOS
import axios from 'axios'
axios.defaults.baseURL = "https://gestionpracticas.comillas.edu";
if (new RegExp(['dev.', 'sandbox'].join("|")).test(location.host)) {
	axios.defaults.baseURL = 'https://sandbox-comillas.dotia.es'
}
if (new RegExp(['localhost'].join("|")).test(location.host)) {
	axios.defaults.baseURL = 'https://localhost:44379'
} 
//.AXIOS

//VEE-VALIDATE
import VeeValidate, {Validator} from 'vee-validate';
import validatorEs from '@/validator/es';
Validator.localize('es', validatorEs);
Vue.use(VeeValidate);
//.VEE-VALIDATE


import i18n from './i18n';

Vue.config.productionTip = false

new Vue({
	el: '#app',
	router,
	i18n,
	store,
  	VeeValidate,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js